import { styled, keyframes } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const pulseGlow = keyframes`
  0%, 100% { box-shadow: 0px 2px 24px 0px rgba(0, 122, 255, 0.48); }
  50% { box-shadow: 0px 2px 32px 0px rgba(0, 122, 255, 0.72); }
`;

const shimmer = keyframes`
  0% { background-position: 200% center; }
  100% { background-position: -200% center; }
`;

const StyledOverlay = styled('div')`
  position: absolute;
  inset: 0;
  z-index: 100;
`;

const StyledBackdrop = styled('div')`
  position: absolute;
  inset: 0;
  backdrop-filter: blur(${({ blurAmount }) => blurAmount || '3px'});
  background: rgba(255, 255, 255, 0.32);
`;

const StyledIndicator = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 12px;
  border-radius: 480px;
  background: ${COLOR.white};
  box-shadow: 0px 2px 24px 0px rgba(0, 122, 255, 0.48);
  white-space: nowrap;
  animation: ${pulseGlow} 2s ease-in-out infinite;
`;

const StyledText = styled('span')`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.4px;
  background: linear-gradient(
    96deg,
    #007aff 0%,
    #66b3ff 25%,
    #007aff 50%,
    #66b3ff 75%,
    #007aff 100%
  );
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${shimmer} 3s linear infinite;
`;

export { StyledOverlay, StyledBackdrop, StyledIndicator, StyledText };
